export const DVTJCUVWorkWithRecSendEmailInviteJobTabs = {
    SEND_EMAIL_INVITE_JOB_TAB: {title: '1.1-Gửi email MỜI JOB', id: 'dvtjcuv-work-with-rec-send-email-invite-job-send-email-invite-job-tab'},
    NEED_FU_TAB: {title: '1.2-Cần FU', id: 'dvtjcuv-work-with-rec-send-email-invite-job-need-fu-tab'},
    SEND_EMAIL_INVITE_JOB_FU_TAB: {title: '1.3-Gửi email MỜI JOB (FU)', id: 'dvtjcuv-work-with-rec-send-email-invite-job-send-email-invite-job-fu-tab'},
}


export const DVTJCUVWorkWithRecCallChatDnRecUpdateInfoSendEmailTabs = {
    DRAFT_TAB: {title: '3.2.1-Duyệt Draft & Gửi email', id: 'draft-tab'},
    NOT_PERMISSION_EMAIL_TAB: {title: '3.2.2-Person bạn chưa có quyền gửi email', id: 'not-permission-email-tab'},
    NEED_CHECKING_TAB: {title: '3.2.3-Person need checking', id: 'need-checking-tab'},
    NEED_INPUT_INFO_TAB: {title: '3.2.4-Person cần nhập bổ sung ttin', id: 'need-input-info-tab'},
    SEND_WHEN_UNLIMITED_TAB: {title: '3.2.5-Person chờ hạn mức', id: 'send-when-unlimited-tab'},
    EXPORTED_WAITING_SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB: {title: '3.2.6-UV đã export, chờ NL Gửi email Đề nghị Receiver update info', id: 'exported-waiting-send-email-tab'}
};

export const DVTJCUVWorkWithRecCallChatDnRecUpdateInfoTabs = {
    RECEIVER_LIST_TAB: {title: '3.1-List Receivers', id: 'email-dn_update-info-receiver-list-tab'},
    SEND_EMAIL_TAB: {title: '3.2-Gửi email', id: 'email-dn_update-info-send-email-tab', childTabs: DVTJCUVWorkWithRecCallChatDnRecUpdateInfoSendEmailTabs},
    // FOLLOW_UP_TAB: {title: '4.3-FU', id: 'email-dn_update-info-follow-up-tab'}
};

export const DVTJCUVWorkWithRecParentTabs = {
    SEND_EMAIL_INVITE_JOB_TAB: {title: '1-Gửi email MỜI GỬI JOB', id: 'dvtjcuv-work-with-rec-send-email-invite-job-tab', childTabs: DVTJCUVWorkWithRecSendEmailInviteJobTabs},
    // TODO: tạm thời dùng tab từ ConnectCddEmpTabs để tạo tab cho Work With Rec
    // CALL_CHAT_DN_REC_UPDATE_INFO_TAB: {title: "2-Call chat ĐN REC UPDATE INFO", id: 'dvtjcuv-work-with-rec-call-chat-dn-rec-update-info-tab'},
    CALL_CHAT_DN_REC_UPDATE_INFO_TAB: {title: "2-Call chat ĐN REC UPDATE INFO", id: 'dvtjcuv-connect-cdd-emp-call-chat-dn-rec-upd-inf-tab'},
    // SEND_EMAIL_DN_REC_UPDATE_INFO_TAB: {title: '3-Gửi email ĐN REC UPDATE INFO', id: 'dvtjcuv-work-with-rec-send-email-dn-rec-update-info-tab', childTabs: DVTJCUVWorkWithRecCallChatDnRecUpdateInfoTabs},
    SEND_EMAIL_DN_REC_UPDATE_INFO_TAB: {title: '3-Gửi email ĐN REC UPDATE INFO', id: 'dvtjcuv-connect-cdd-emp-send-email-receiver-update-info-tab', childTabs: DVTJCUVWorkWithRecCallChatDnRecUpdateInfoTabs},
}

export const DVTJCUVWorkWithRecSendEmailInviteJobSendEmailTabs = {
    DRAFT_TAB: {title: '1.1.1-Duyệt Draft & Gửi email', id: 'draft-tab'},
    NOT_PERMISSION_EMAIL_TAB: {title: '1.1.2-Rec bạn chưa có quyền gửi email', id: 'not-permission-email-tab'},
    NEED_CHECKING_TAB: {title: '1.1.3-Rec need checking', id: 'need-checking-tab'},
    NEED_INPUT_INFO_TAB: {title: '1.1.4-Rec cần nhập bổ sung ttin', id: 'need-input-info-tab'},
    SEND_WHEN_UNLIMITED_TAB: {title: '1.1.5-Rec chờ hạn mức', id: 'send-when-unlimited-tab'},
    EXPORTED_WAITING_SEND_EMAIL_TAB: {title: '1.1.6-Rec đã export', id: 'exported-waiting-send-email-tab'}
};

export const DVTJCUVWorkWithRecSendEmailInviteJobSendEmailFUTabs = {
    DRAFT_TAB: {title: '1.3.1-Duyệt Draft & Gửi email', id: 'draft-tab'},
    NOT_PERMISSION_EMAIL_TAB: {title: '1.3.2-Rec bạn chưa có quyền gửi email', id: 'not-permission-email-tab'},
    NEED_CHECKING_TAB: {title: '1.3.3-Rec need checking', id: 'need-checking-tab'},
    NEED_INPUT_INFO_TAB: {title: '1.3.4-Rec cần nhập bổ sung ttin', id: 'need-input-info-tab'},
    SEND_WHEN_UNLIMITED_TAB: {title: '1.3.5-Rec chờ hạn mức', id: 'send-when-unlimited-tab'},
    EXPORTED_WAITING_SEND_EMAIL_TAB: {title: '1.3.6-Rec đã export', id: 'exported-waiting-send-email-tab'}
};


